import { filterOptions } from '@/utils/query-base'

const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  'invoicingcustomer': {
    title: '开票客户编码'
  },
  'invoicingcustomername': {
    title: '开票客户名称',
    width: 200
  },
  'ordercustomer': {
    title: '订单客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '订单客户'
    }
  },
  'ordercustomername': {
    title: '订单客户名称',
    width: 200
  },
  'zzfld000001': {
    describe: true, // 描述 _text 添加属性
    suffix: 'TextView',
    title: '营销单元', // 字段名称
    type: 'select', // 输入类型 下拉
    equation: all, // 条件
    dictionary: 'sale', // 字典 （营销单元(sale)， 基地(base)，省(region)，市(city)，区(street)）
    width: 140
  },
  'brandBq': {
    title: '品牌',
    describe: true,
    suffix: 'TextView',
    type: 'select',
    equation: city,
    dictionary: 'A0018'
  },
  'orderedProd': {
    title: '产品',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ProductSelect',
      title: '产品编码'
    },
    width: 200
  },
  'description': {
    title: '产品名称',
    width: 350
  },
  'province': {
    title: '省',
    type: 'select',
    equation: city,
    dictionary: 'region'
  },
  'city': {
    title: '市',
    type: 'select',
    equation: city,
    dictionary: 'city'

  },
  'invType': {
    describe: true,
    title: '发票类型',
    suffix: 'TextView',
    type: 'select',
    equation: city,
    dictionary: 'A0032'
  },
  'invProperty': {
    describe: true,
    suffix: 'TextView',
    title: '发票性质',
    type: 'select',
    equation: city,
    dictionary: 'inv_property'
  },
  'usezzfld9': {
    title: '开票量',
    xlsxFmt: {
      t: 'n'
    }
  },

  'transferqty': {
    title: '货权转移量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'approvingnum': {
    title: '要货正在审批量',
    width: 140,
    xlsxFmt: {
      t: 'n'
    }

  },
  'usednum': {
    title: '要货审批完成量',
    width: 140,
    xlsxFmt: {
      t: 'n'
    }
  },
  'occupancynum': {
    title: '占用量合计',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remainnum': {
    title: '剩余量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'makDate': {
    title: '开票日期',
    type: 'date',
    equation: all
  },
  'isClear': {
    describe: true,
    suffix: 'TextView',
    title: '是否结清',
    type: 'whetherN',
    equation: city
  }
}



// WEBPACK FOOTER //
// ./src/views/report-forms-manage/config/saleCenterInvReportForms.js